@if(showProgressStepper$()) {
  <mat-stepper class="progress-flow" [selectedIndex]="selectedIndex" [labelPosition]="'bottom'" [color]="'primary'" [linear]="false"
    [orientation]="'horizontal'" #stepper ngClass="{{ 'last-edited-step-' + stepper.selectedIndex }}">

    @for(workflowSection of workflowSections$(); track $index){

    <ng-template matStepperIcon="number" let-index="index">

        @if(selectedIndex === index) {
          <svg-icon name="in-progress"></svg-icon>
        }
        @if(selectedIndex < index) {
          <svg-icon name="not-started"></svg-icon>
        }
        @if(selectedIndex > index) {
          <svg-icon name="completed"></svg-icon>
        }

    </ng-template>
    <mat-step [label]="selectedIndex === $index ? workflowSection.step.name : ''" [completed]="workflowSection.step.status === 'completed'">
    </mat-step>
    }
  </mat-stepper>
}
